import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import TransferStudentService from "../service/transferStudent";
import HttpClient from "../network/http";
import { fetchCsrfToken, useAuthContext } from "../context/AuthContext";

const baseURL = process.env.REACT_APP_BASE_URL;

export default function useTransferStudent(conditions) {
  //location.path로 학교 아이디, role은 파람으로 모든 정보 가져오기
  const queryClient = useQueryClient();
  const { address } = useAuthContext();
  const httpClient = new HttpClient(baseURL, () => fetchCsrfToken(), address);
  const transferStudentService = new TransferStudentService(httpClient);
  // console.log("conditions", conditions);
  //users db에서 transferStudent join해서 가져온다.
  const transferStudentQuery = useQuery(
    ["transferStudent", conditions], // queryKey에 flexible_data_id 추가
    () => transferStudentService.findAllTransferStudent(conditions),
    {
      enabled: !!conditions?.schoolid && !!conditions?.username,
      staleTime: 1000 * 60 * 5, //5분,
      // onSuccess: (data) => {
      //   console.log("transferStudent Query Data:", data);
      // },
    }
  );

  const createTransferStudent = useMutation(
    (activity) => transferStudentService.createTransferStudent(activity),
    {
      onSuccess: () => queryClient.invalidateQueries(["transferStudent"]),
      // onError: (error) => {
      //   console.error("Error creating:", error);
      // },
    }
  );

  const updateTransferStudent = useMutation(
    (activity) => transferStudentService.updateTransferStudent(activity),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["transferStudent"]);
      },
      // onError: (error) => {
      //   // Handle the failure by displaying an error message or performing other actions
      //   console.error("Error updating transferStudent:", error);
      //   alert(error);
      //   // Add your error handling logic here
      // },
    }
  );
  const deleteTransferStudent = useMutation(
    (id) => transferStudentService.deleteTransferStudent(id),
    {
      onSuccess: () => {
        console.log("Mutation success, invalidating transferStudent query...");
        queryClient.invalidateQueries(["transferStudent"]).then(() => {
          console.log("TransferStudent query invalidated, should refetch...");
        });
      },
    }
  );

  const findTransferStudent = useMutation(
    (conditions) =>
      transferStudentService.findAllTransferStudentByFlexibleDataId(conditions),
    {
      onError: (error) => {
        console.error("Error finding transferStudent:", error);
      },
    }
  );

  return {
    transferStudentQuery,
    createTransferStudent,
    updateTransferStudent,
    deleteTransferStudent,
    findTransferStudent,
  };
}
